import React, {memo} from "react";
import { useNavigate} from 'react-router-dom';

import {ThemeProvider, Container, Typography } from '@mui/material';
import {ThemeCustom} from '../styles/Theme.js';
import 'simplebar-react/dist/simplebar.min.css';

import ButtonMain from "../components/button/Button_main.js";

import NotFoundImg from '../assets/404.svg';

const NotFound = () => {

    const navigate = useNavigate()


    return(
        <ThemeProvider theme={ThemeCustom}>
            <Container maxWidth="xl" className="p-5">
                <div className="mb-7 flex flex-col justify-center items-center">
                    <img src={NotFoundImg} alt={`404`} className="max-w-[40rem] w-full max-h-[calc(100vh-12.25rem)]"/>
                    <Typography variant="textheader3" component={'div'}>Page Not Found!</Typography>                    
                    <ButtonMain 
                        variant='primary' 
                        type='button' 
                        disabled={false} 
                        name='Back to Home'
                        class='capitalize mt-7'
                        onClick={()=>navigate(`/job-board`)}
                    />
                </div>
            </Container>
        </ThemeProvider>
    )
}

export default memo(NotFound);